
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Linkedin, ChevronDown } from "lucide-react";
import { SiGlassdoor } from "react-icons/si";

const footerData = {
  services: [
    { name: "Automation & Agentic AI", link: "/automation-and-ai-agents" },
    { name: "ServiceNow", link: "/servicenow" },
    { name: "Data Platforms", link: "/data-ai-databricks-solution" },
    { name: "Digital Engineering", link: "/digital-engineering" },
  ],
  capabilities: [
    { name: "Capabilities", link: "/capabilities" },
    { name: "Industries", link: "/industries" },
  ],
  products: [
    { name: "Glodesk", link: "/glodesk" },
    { name: "Glokode", link: "/glokode" },
  ],
  company: [
    { name: "About Us", link: "/who-we-are" },
    { name: "Contact Us", link: "/contact" },
    { name: "Careers", link: "/all-openings" },
  ],
};

const socialLinks = [
  {
    name: "LinkedIn",
    link: "https://in.linkedin.com/company/mobikode-software",
    icon: <Linkedin size={19} />,
  },
  {
    name: "Glassdoor",
    link: "https://www.glassdoor.com/Overview/Working-at-Mobikode-EI_IE5348831.11,19.htm",
    icon: <SiGlassdoor size={19} />,
  },
];

const FooterLink = ({ item }) => (
  <li>
    <Link
      to={item.link}
      className="text-[14px] sm:text-[15px] font-roboto text-white/90 hover:text-white transition-colors duration-300 break-words"
    >
      {item.name}
    </Link>
  </li>
);

const SocialIcon = ({ item }) => (
  <a
    href={item.link}
    target="_blank"
    rel="noopener noreferrer"
    aria-label={item.name}
    className="w-[42px] h-[42px] shrink-0 border border-white/90 flex items-center justify-center text-white hover:bg-white hover:text-[#002F8D] transition-all duration-300"
  >
    {item.icon}
  </a>
);

// MOBILE ONLY ACCORDION
const MobileAccordion = ({ title, items }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
<div className="border-b border-white/25 last:border-b-0 lg:hidden">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between py-4 text-left"
      >
        <span className="font-graphik text-[15px] font-semibold text-white">
          {title}
        </span>

        <ChevronDown
          size={18}
          className={`text-white transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen
            ? "grid-rows-[1fr] opacity-100 pb-5"
            : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <ul className="flex flex-col gap-3 pl-1">
            {items.map((item, index) => (
              <FooterLink key={index} item={item} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

// POLICIES DROPDOWN
const PoliciesDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  const policies = [
    { name: "FAQ", link: "/faq" },
    { name: "Terms & Conditions", link: "/terms-condition" },
    { name: "Privacy Policy", link: "/privacy-policy" },
  ];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        className="flex items-center gap-2 font-graphik text-[15px] sm:text-[16px] text-white hover:text-white/70 transition-colors whitespace-nowrap"
      >
        Policies

        <ChevronDown
          size={15}
          className={`transition-transform duration-300 ${
            isOpen ? "rotate-180" : ""
          }`}
        />
      </button>

      {isOpen && (
        <>
          <button
            type="button"
            aria-label="Close policies menu"
            onClick={() => setIsOpen(false)}
            className="fixed inset-0 z-40 cursor-default"
          />

          <div className="absolute bottom-full left-0 mb-3 w-[200px] max-w-[calc(100vw-40px)] bg-white shadow-xl border border-gray-200 py-2 z-50">
            {policies.map((item, index) => (
              <Link
                key={index}
                to={item.link}
                onClick={() => setIsOpen(false)}
                className="block px-4 py-2.5 text-[13px] font-roboto text-[#191B1F] hover:bg-[#F3F1EF] hover:text-[#002F8D] transition-colors duration-200"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const NewFooter = () => {
  return (
    <footer
      className="relative w-full overflow-hidden text-white font-roboto"
      style={{
        background: "linear-gradient(180deg, #002F8D 0%, #000000 100%)",
      }}
    >
      <div className="w-full max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-10 xl:px-12">

        {/* MAIN FOOTER CONTENT */}
        <div
          className="
            grid
            grid-cols-1
            min-[480px]:grid-cols-2
            lg:grid-cols-3
            xl:grid-cols-[1.3fr_1.2fr_0.85fr_0.8fr_1fr]
            gap-x-5
            xl:gap-x-8
            gap-y-10
            sm:gap-y-12
            pt-[55px]
            md:pt-[60px]
            pb-[55px]
          "
        >

          {/* BRAND & CONTACT */}
          <div className="flex flex-col items-start min-w-0">

     <Link to="/" className="inline-block mb-5">
    <img
        src="/assets/nav/newlogo.png"
        alt="Panchtantra One"
        className="h-[30px] sm:h-[60px] lg:h-[50px] w-auto object-contain object-left"
    />
</Link>

            <div className="flex flex-col gap-3">
              <p className="font-graphik text-[14px] font-medium text-white/85">
                Email
              </p>

              <a
                href="mailto:sales@mobikode.com"
                className="font-roboto text-[16px] lg:text-[17px] font-medium text-white hover:text-white/75 transition-colors break-all"
              >
                sales@mobikode.com
              </a>
            </div>
          </div>

          {/* DESKTOP SERVICES */}
          <div className="hidden lg:block min-w-0 lg:pl-8 xl:pl-12">
            <h3 className="font-graphik text-[17px] font-bold text-white mb-[25px]">
              Services
            </h3>

            <ul className="flex flex-col gap-[14px]">
              {footerData.services.map((item, i) => (
                <FooterLink key={i} item={item} />
              ))}
            </ul>
          </div>

          {/* DESKTOP CAPABILITIES */}
          <div className="hidden lg:block min-w-0 lg:pl-2">
            <h3 className="font-graphik text-[17px] font-bold text-white mb-[25px]">
              Capabilities
            </h3>

            <ul className="flex flex-col gap-[14px]">
              {footerData.capabilities.map((item, i) => (
                <FooterLink key={i} item={item} />
              ))}
            </ul>
          </div>

          {/* DESKTOP PRODUCTS */}
          <div className="hidden lg:block min-w-0">
            <h3 className="font-graphik text-[17px] font-bold text-white mb-[25px]">
              Products
            </h3>

            <ul className="flex flex-col gap-[14px]">
              {footerData.products.map((item, i) => (
                <FooterLink key={i} item={item} />
              ))}
            </ul>
          </div>

          {/* DESKTOP COMPANY */}
          <div className="hidden lg:block min-w-0">
            <h3 className="font-graphik text-[17px] font-bold text-white mb-[25px]">
              Company
            </h3>

            <ul className="flex flex-col gap-[14px]">
              {footerData.company.map((item, i) => (
                <FooterLink key={i} item={item} />
              ))}
            </ul>
          </div>

        </div>

        {/* MOBILE ACCORDION */}
        <div className="lg:hidden -mt-5">

          <MobileAccordion
            title="Services"
            items={footerData.services}
          />

          <MobileAccordion
            title="Capabilities"
            items={footerData.capabilities}
          />

          <MobileAccordion
            title="Products"
            items={footerData.products}
          />

          <MobileAccordion
            title="Company"
            items={footerData.company}
          />

        </div>

        {/* SECONDARY FOOTER */}
     
{/* SECONDARY FOOTER */}
<div
  className="
    flex
    flex-col
    md:flex-row
    items-start
    md:items-center
    justify-between
    gap-6
    py-7
    border-t
    border-white/25
  "
>
  {/* LEFT SIDE */}
  <div className="flex flex-wrap items-center gap-6 sm:gap-8">

    <PoliciesDropdown />

    <Link
      to="/disclaimer"
      className="font-graphik text-[15px] sm:text-[16px] text-white hover:text-white/70 transition-colors whitespace-nowrap"
    >
      Disclaimer
    </Link>

    {/* SOCIAL ICONS */}
    <div className="flex items-center gap-3">
      {socialLinks.map((item, i) => (
        <SocialIcon key={i} item={item} />
      ))}
    </div>

  </div>

  {/* RIGHT SIDE - COPYRIGHT */}
  <p className="font-graphik text-[13px] sm:text-[14px] lg:text-[15px] text-white/90">
    © 2026 Mobikode. All Rights Reserved.
  </p>

</div>

      </div>
    </footer>
  );
};

export default NewFooter;
